import { createEffect, createEvent, createStore, sample } from 'effector';
import { createDialog } from '../../util/createDialog';
import { VOID } from '../../util/JsonUtils';
import { $$gcp } from '../../services/GcpService/model.ts';
import { $$snackbar } from '../../components/SnackbarRoot/model';
import { spread } from 'patronum';
import { ghApi } from '../../services/DataService';
import { $$app } from '../../components/App/model.tsx';
import { hasKnowledgeBasePermission } from '../../services/PermissionService/PermissionService.ts';

const $$releaseNotesDialog = createDialog();

//-------------------------------- Events --------------------------------
const reinitAll = createEvent<void>();
const pageMounted = createEvent<boolean>();
const releaseNotesButtonClicked = createEvent<void>();

//-------------------------------- Stores --------------------------------
const $gcpVersions = createStore<GcpVersion[]>(null).reset(reinitAll);
const $documentationHtml = createStore<string>(null).reset(reinitAll);

//-------------------------------- Samples --------------------------------
sample({
  clock: releaseNotesButtonClicked,
  target: [$$releaseNotesDialog.open, $$gcp.getGcpVersionsFx]
});

sample({
  clock: $$gcp.getGcpVersionsFx.doneData,
  target: $gcpVersions
});

sample({
  clock: $$gcp.getGcpVersionsFx.fail,
  fn: () => ({
    gcpVersions: [],
    closeDialog: VOID,
    snackbarMessage: { message: `Error loading release notes`, severity: 'error' }
  }),
  target: spread({
    gcpVersions: $gcpVersions,
    closeDialog: $$releaseNotesDialog.close,
    snackbarMessage: $$snackbar.open
  })
});

const getDocumentationHtmlFx = createEffect<void, string>(async () => {
  return ghApi.get('/documentation/knowledgeBase').then(res => res.data);
});

sample({
  source: $$app.$userDetails,
  clock: pageMounted.filter({ fn: Boolean }).map(() => ({})),
  filter: userDetails => hasKnowledgeBasePermission(userDetails?.permissions),
  target: getDocumentationHtmlFx
});

sample({
  clock: getDocumentationHtmlFx.doneData,
  target: $documentationHtml
});

export const $$documentation = {
  $$releaseNotesDialog,

  $gcpVersions,
  $documentationHtml,

  pageMounted,
  releaseNotesButtonClicked,

  __: {
    reinitAll
  }
};
